import { CheckInCompletion } from "components/types"
import React from "react"

import { FaCheck, FaCheckGoal } from "../../AppReactIcons"

interface CircleFillProps {
  completed: CheckInCompletion
  date: string
  onClick: (date: string, completed: number) => void
}

export const GoalReviewCircleIndicator: React.FC<CircleFillProps> = ({
  completed,
  date,
  onClick,
}) => {
  const weekdays = ["S", "M", "T", "W", "T", "F", "S"] // This will convert the index to the first letter of the day of the week
  const dayOfWeek = new Date(date).getDay() // This will get the day from the date

  if (completed === 0) {
    return (
      <button
        className="rounded-full bg-gray-500 text-site-white w-6 h-6 flex justify-center items-center font-light"
        onClick={() => onClick(date, completed)}
      >
        <FaCheckGoal />
      </button>
    )
  } else if (completed == 1) {
    return (
      <button
        className="rounded-full bg-gray-500 text-site-white w-6 h-6 flex justify-center items-center"
        onClick={() => onClick(date, completed)}
      >
        <FaCheckGoal />
      </button>
    )
  } else if (completed == 2) {
    return (
      <button
        className="rounded-full bg-gray-500 text-site-white w-6 h-6 flex justify-center items-center"
        onClick={() => onClick(date, completed)}
      >
        <p className="text-sm">{weekdays[dayOfWeek]}</p>
      </button>
    )
  } else if (completed == 3) {
    return (
      <button
        className="rounded-full bg-gray-500 text-site-white w-6 h-6 flex justify-center items-center"
        onClick={() => onClick(date, completed)}
      >
        <p className="text-sm">{weekdays[dayOfWeek]}</p>
      </button>
    )
  }
  return null
}
